<div class="container" *ngIf="!loading">
    <div class="row">
        <div class="col-sm-12">
            <h4>Gutscheine</h4>
        </div>
    </div>

    <div class="row marginBottom2Rem" [formGroup]="filterForm">
        <div class="col-sm-3">
            <mat-form-field class="full-width" appearance="fill">
                <mat-label>Suche</mat-label>
                <input type="text" matInput formControlName="searchTerm" placeholder="suchen.."
                    (keydown)="onKeydown($event)">
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Aktionsstatus</mat-label>
                <mat-select formControlName="eventStates" multiple>
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.eventStates.value != null ">
                            {{this.filterForm.controls.eventStates.value | translateFilterReservation : 'eventStates'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.eventStates.value?.length > 1">
                            (+{{this.filterForm.controls.eventStates.value.length - 1 }}
                            {{this.filterForm.controls.eventStates.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of eventStates" [disabled]="sortOption.state"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Zahlungsstatus</mat-label>
                <mat-select formControlName="filterByPaymentStates" multiple>
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByPaymentStates.value != null ">
                            {{this.filterForm.controls.filterByPaymentStates.value | translateFilterReservation :
                            'filterByPaymentStates'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByPaymentStates.value?.length > 1">
                            (+{{this.filterForm.controls.filterByPaymentStates.value.length - 1 }}
                            {{this.filterForm.controls.filterByPaymentStates.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of paymentStates" [disabled]="sortOption.state"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="col-sm-3">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Status</mat-label>
                <mat-select formControlName="filterByStates" multiple>
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.filterByStates.value != null ">
                            {{this.filterForm.controls.filterByStates.value | translateFilterReservation :
                            'filterByStates'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.filterByStates.value?.length > 1">
                            (+{{this.filterForm.controls.filterByStates.value.length - 1 }}
                            {{this.filterForm.controls.filterByStates.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let sortOption of States" [disabled]="sortOption.state"
                        [value]="sortOption.value">{{sortOption.viewValue}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div class="col-sm-3" *ngIf="this.showMoreFilter">
            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Partner</mat-label>
                <mat-select formControlName="eventPartnerPublicIds" multiple>
                    <mat-select-trigger>
                        <span *ngIf="this.filterForm.controls.eventPartnerPublicIds.value != null ">
                            {{this.filterForm.controls.eventPartnerPublicIds.value | translateFilterReservation :
                            'eventPartnerPublicIds'}}
                        </span>
                        <span *ngIf="this.filterForm.controls.eventPartnerPublicIds.value?.length > 1">
                            (+{{this.filterForm.controls.eventPartnerPublicIds.value.length - 1 }}
                            {{this.filterForm.controls.eventPartnerPublicIds.value?.length === 2 ? 'anderer'
                            :'andere' }})
                        </span>
                    </mat-select-trigger>
                    <mat-option *ngFor="let partner of partners" [value]="partner">
                        {{partner?.name}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <button mat-button mat-raised-button color="accent" (click)="filterReservations()">
                Anwenden
            </button>
            <button mat-button mat-raised-button color="primary" (click)="showmoreFilters()"
                *ngIf="!this.showMoreFilter" style="margin-left: 15px;">
                Mehr anzeigen
            </button>
            <button mat-button mat-raised-button color="primary" (click)="showLessFilters()" *ngIf="this.showMoreFilter"
                style="margin-left: 15px;">
                Weniger anzeigen
            </button>
            <button mat-button mat-raised-button color="primary" (click)="resetFilter()" style="margin-left: 15px;"
                [disabled]="!this.filterForm.touched">
                Filter zurücksetzen
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 ">
            <div class="actionRow mat-elevation-z2">
                <div>
                    <!-- <button mat-icon-button [disabled]="canPrintAllReservations == false"
                        (click)="printAllReservations()"  matTooltip="Gutscheine drucken">
                        <mat-icon>print</mat-icon>
                    </button> -->
                    <button mat-icon-button (click)="useAllReservations()" matTooltip="Gutscheine einlösen"
                        [disabled]="this.canUseAllReservations == false">
                        <mat-icon matTooltip="Gutscheine einlösen">check</mat-icon>
                    </button>
                    <button mat-icon-button (click)="cancelAllVouchers()" matTooltip="Gutscheine stornieren"
                        [disabled]="this.canCancelAllVouchers == false">
                        <mat-icon>cancel</mat-icon>
                    </button>
                    <button mat-icon-button (click)="cancelAllReservations()" matTooltip="Einlösungen stornieren"
                        [disabled]="this.canCancelAllReservations == false">
                        <mat-icon>cancel_presentation</mat-icon>
                    </button>
                </div>
                <h6>
                    {{this.selectedReservations.length}} Gutscheine ausgewählt
                </h6>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <div class="example-container mat-elevation-z2">
                <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z2">
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef style="padding-left: 24px;">
                            <mat-checkbox (change)="selectAll()" [checked]="this.selectedAll"></mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <mat-checkbox (change)="selectReservation(element)" [checked]="element.selected">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef>
                            #
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index;" class="mat-column">
                            {{i+1}}
                        </td>
                    </ng-container> -->
                    <ng-container matColumnDef="voucherKey">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Code
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            {{element.voucherKey}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="event.title">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Aktion
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <span class="customLink"
                                [routerLink]="['../../caseworker/event/edit/'+element.eventPublicId+'/advanced']">
                                {{element.eventTitle}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="event.partner.name">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Partner
                        </th>
                        <td mat-cell *matCellDef="let element" class="mat-column">
                            <span class="customLink" color="primary"
                                [routerLink]="['../../caseworker/businessentity/edit', element.partnerPublicId]">
                                {{element.eventV2.eventPartner.name}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="attendingAccount.displayName" class="mat-column">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                            Teilnehmer
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="customLink"
                                [routerLink]="['../../caseworker/dashboard/edit', element.customerPublicId]">
                                {{element.customerDisplayName}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="created" class="mat-column">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef matSortDirection="desc"
                            matSortDisableClear>
                            Erstellungsdatum
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.created | date: 'medium' : 'GMT' : 'de-DE'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="state" class="mat-column ">
                        <th mat-header-cell *matHeaderCellDef>
                            Status
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected *ngIf="element.state == 'RESERVED' ">
                                    {{element.state | translateState}}
                                </mat-chip>
                                <mat-chip class="accentChip" selected *ngIf="element.state != 'RESERVED' ">
                                    {{element.state | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="paymentstate" class="mat-column ">
                        <th mat-header-cell *matHeaderCellDef>
                            Zahlungsstatus
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-chip-set>
                                <mat-chip class="primaryChip" selected *ngIf="element.paymentState == 'PAID' ">
                                    {{element.paymentState | translateState}}
                                </mat-chip>
                                <mat-chip class="accentChip" selected *ngIf="element.paymentState != 'PAID' ">
                                    {{element.paymentState | translateState}}
                                </mat-chip>
                            </mat-chip-set>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef>
                            Menü
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button style="margin: 0 auto !important;" [matMenuTriggerFor]="menu"
                                color="accent">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item [disabled]="!canUse(element)"
                                    (click)="useReservation(element.publicId)">
                                    <span>Gutschein einlösen</span>
                                </button>
                                <button mat-menu-item [disabled]="!canCancelReservationUsage(element)"
                                    (click)="delteAlreadyUsesReservation(element.publicId)">
                                    <span>Einlösung stornieren</span>

                                </button>
                                <button mat-menu-item [disabled]="!canCancel(element)"
                                    (click)="delteReservation(element.publicId)">
                                    <span *ngIf="element.eventV2.eventDiscount  != 'RAFFLE'">Gutschein stornieren</span>
                                    <span *ngIf="element.eventV2.eventDiscount  == 'RAFFLE'">Teilnahme stornieren</span>
                                </button>
                                <button mat-menu-item (click)="getPDF(element.publicId)"
                                    [disabled]="!canPrint(element)">
                                    <span>Gutschein Drucken</span>
                                </button>
                                <button mat-menu-item
                                    [routerLink]="['../../caseworker/reservation/plus', element.customerPublicId]">
                                    <span>Zum Vorteilskonto</span>
                                </button>
                                <button mat-menu-item
                                    [routerLink]="['../../caseworker/dashboard/edit', element.customerPublicId]">
                                    <span>Zum Kunden</span>
                                </button>

                                <button mat-menu-item
                                    [routerLink]="['../../caseworker/event/edit/'+element.eventPublicId+'/advanced']">
                                    <span>Zur Aktion</span>
                                </button>
                                <button mat-menu-item
                                    [routerLink]="['../../caseworker/businessentity/edit', element.partnerPublicId]">
                                    <span>Zum Partner</span>
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;let i = index">
                    </tr>
                </table>
                <span *ngIf="dataSource?.data.length === 0" class="emptyTableState  mat-elevation-z2">Keine passenden
                    Einträge
                    gefunden...</span>
                <mat-paginator [length]="page.totalElements" class="paginator-centered  mat-elevation-z2"
                    [pageSize]="page.size" [pageIndex]="page.number" (page)="loadPage($event)"
                    [pageSizeOptions]="[6, 12, 24, 36]" *ngIf="page">
                </mat-paginator>
            </div>
            <button class="fabAddBtnBottomRight" mat-fab color="accent" [routerLink]="['add']">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>
<div class="container" *ngIf="loading">
    <div class="row">
        <div class="col-sm-12 padding">
            <div class="loadingOverlay">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </div>
</div>